import TripList from './components/TripList/Index'
import TripForm from './components/TripForm/Index'

export default {
    name: 'Trips',
    components: {
        TripList,
        TripForm
    }
}
